import styled from 'styled-components';
import * as FiIcons from 'react-icons/fi';
import { Link } from 'react-router-dom';
import * as BiIcons from 'react-icons/bi';

export const Overlay = styled.div`
  // background-color: skyblue;

  width: 100%;
`;

export const Borderline = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  border-left: 1px solid #d5d5d5;
  height: 200px;
`;

export const Container = styled.div`
  justify-content: center;
  margin-right: 5%;
`;

export const RightContainer = styled.div`
  min-height: 834px;
  margin-top: 30px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 10px 30px 30px 30px;
  max-width: 963px;
`;

export const LeftContainer = styled.div`
  width: max-content;
  height: 40%;
  margin-right: 30px;
`;

export const BenefitsContainer = styled.div`
  background-color: white;
  padding: 10px 30px 30px 30px;
  border-radius: 4px;
  max-width: 375px;
  margin-top: 30px;
  min-height: 585px;
`;

export const PichartContainer = styled.div`
  // background-color: ORANGE;
  width: 1000px;
`;

export const PayHistoryContainer = styled.div`
  background-color: white;
  border-radius: 4px;
  width: 1355px;
  height: 350px;
  padding: 10px 30px 30px 30px;
`;

export const PayHistoryColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 1355px;
`;

export const RecentPaystub = styled.div`
  background: #4948ac;
  min-width: 176px;
  width: 200px;
  height: 240px;
`;

export const PaystubIcon = styled.img`
  width: auto;
  height: 35px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  height: max-content;
  align-items: center;
  justify-content: space-between;
`;

export const DropdownContainer = styled.div`
  width: 95%;
  display: flex;
  justify-content: space-between;
`;

export const PayHistoryRedirectButton = styled(Link)`
  display: flex;
  height: 31px;
  width: 117px;
  margin-left: 35px;
  margin-top: 16px;
  flex-direction: column;
  font: normal normal normal 16px Biotif;
  letter-spacing: 0px;
  color: white;

  border: 1px solid white;
  align-items: center;
  justify-content: center;
  background: #4948ac 0% 0% no-repeat padding-box;
  text-decoration: none;
  &:hover {
    background-color: #2dcaff;
    transition: 0.75s;
  }
`;

export const BenefitsallButton = styled.button`
  display: flex;
  height: 31px;
  width: 117px;
  font: normal normal normal 16px Biotif;
  color: white;
  align-items: center;
  border: 1px solid white;
  justify-content: center;
  background: #4948ac;
  text-decoration: none;
  &:hover {
    background-color: #2dcaff;
    transition: 0.75s;
    cursor: pointer;
  }
`;

export const HiddenBtn = styled.button`
  background-color: inherit;
  width: max-content;
  height: max-content;
  border: none;
`;

export const TrashIcon = styled(FiIcons.FiTrash2)`
  pointer-events: none;
`;

export const ReceiptIcon = styled(BiIcons.BiReceipt)`
  height: 48px;
  width: auto;
  margin-left: 70px;
  margin-top: 8px;

  &:hover {
    fill: #fff;
  }
`;

export const PaystubText = styled.p`
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 0;
  margin-right: 15px;
  margin: 0.5em;
  font-size: 1.6rem;
  font-family: Biotif, sans-serif;
  width: 55%;
`;

export const PayHistoryQuantity = styled(Link)`
  display: flex;
  width: 210px;
  height: 139px;
  flex-direction: column;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 16px #00000029;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
`;

export const PaystubQuantityNumberText = styled.p`
  color: #222247;
  line-height: 5.8rem;
  font: normal bold 5.8rem/1 Biotif;
  padding: 0;
  margin: 0;
  text-align: center;
`;

export const PaystubQuantityText = styled.p`
  text-align: center;
  font: normal normal normal 1.6rem Biotif;
  letter-spacing: 0px;
  color: #222247;
  padding: 0;
  margin: 0;
`;

// export const HeaderContainer1 = styled.div`
//   display: flex;
//   gap: ${(props) => props.gap || '20px'}; /* Customize the gap using props */
// `;

export const HeaderText = styled.h1`
  font-size: 20px; /* Main Header Font Size */
`;

export const HeaderText1 = styled.h2`
  font-size: 16px;
  margin-top: 27px;
`;

export const SubHeaderText = styled.h4`
  color: #707070;
  margin-left: -12px;
  font-family: Biotif, sans-serif;
`;

export const RightHeaderContainer = styled.div`
  display: flex;
  height: max-content;
  align-items: center;
  justify-content: normal;
`;

export const MainNotification = styled.div`
  flex-direction: column;
  margin-top: 2%;
`;
